import artifact from '$houdini/artifacts/LIB_updateInventoryBasic'
import { MutationStore } from '../runtime/stores/mutation'

export class LIB_updateInventoryBasicStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
